import React, { useState } from 'react'
import { Box, Button } from '@material-ui/core'
import { Divider, Grid, Tooltip } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { DRIVE_FEATURES } from 'src/utils/constants/BuyPolicyMotor'
import { COLORS } from 'src/utils/Themes/colors'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { useHistory } from 'react-router-dom'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import {
  updateCurrentPolicyDetailsMotor,
  updateSelectedQuoteMotor,
} from 'src/actions'
import { useDispatch, useSelector } from 'react-redux'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { POLICY_TYPES } from 'src/utils/constants/BuyPolicy'

const ComprehensivePlan = (props) => {
  const { quote, logo, idvCover, price, paCover, policyType } = props
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state.buyPolicyMotorReducer)
  const currentPolicyDetails = motorDetails.currentPolicyDetails
  const isCoverageAvailable = false
  const selectedAddOns = currentPolicyDetails?.selectedAddOns
  const [showAddOns, setShowAddOns] = useState(false)

  const getIconById = (id) => {
    const match = quote?.addOns?.find((item) => item?.id === id)

    if (match) {
      return <CheckIcon size='small' className={classes.checkAddOn} />
    } else {
      return <ClearIcon size='small' className={classes.crossAddOn} />
    }
  }

  const handleQuoteClick = () => {
    dispatch(updateSelectedQuoteMotor(quote))
    if (paCover) {
      dispatch(
        updateCurrentPolicyDetailsMotor({
          ...currentPolicyDetails,
          paPremium: quote?.paPremium,
        })
      )
    }

    if (motorDetails.vehicleDetails.vehicleType === VEHICLE_TYPE?.TWO_WHEELER) {
      history.push(
        '/individual/dashboard/buyPolicy/bike/insuranceDetails/member-details'
      )
    } else {
      history.push(
        '/individual/dashboard/buyPolicy/motor/insuranceDetails/member-details'
      )
    }
  }

  const handleViewPlanDetails = () => {
    dispatch(updateSelectedQuoteMotor(quote))
    if (paCover) {
      dispatch(
        updateCurrentPolicyDetailsMotor({
          ...currentPolicyDetails,
          paPremium: quote?.paPremium,
        })
      )
    }
    if (motorDetails.vehicleDetails.vehicleType === VEHICLE_TYPE?.TWO_WHEELER) {
      history.push(
        '/individual/dashboard/buyPolicy/bike/insuranceDetails/plan-details'
      )
    } else {
      history.push(
        '/individual/dashboard/buyPolicy/motor/insuranceDetails/plan-details'
      )
    }
  }

  return (
    <Box className={classes.quote}>
      <Box className={classes.backgroundContainer}>
        <Box className={classes.quoteCardContainer}>
          <Box className={classes.quoteCard}>
            <Box className={classes.logoContainer}>
              <img src={logo} alt='card-logo' className={classes.logoImage} />
            </Box>
            <Box className={classes.quoteDetailsRow}>
              <Box className={classes.heading} id='idvCover'>
                IDV Cover
              </Box>
              <Box className={classes.data}>{formatToINR(idvCover)}</Box>
            </Box>
            {policyType !== POLICY_TYPES?.OWN_DAMAGE ? (
              <Box className={paCover ? null : classes.paCoverDisabled}>
                <Box
                  className={classes.paCoverProviderName}
                  id='paCoverProviderName'
                >
                  {quote.providerName}
                </Box>
                <Box className={classes.paCoverTileText}>
                  <Box className={classes.paCoverText}>PA Cover</Box>{' '}
                  <Box>
                    <Tooltip
                      arrow
                      title={
                        paCover ? (
                          <>
                            <Box>
                              This cover offers financial support to the car
                              owner in the event of disability or death
                              resulting from an accident.
                            </Box>

                            <Box>
                              According to IRDAI guidelines, every individual
                              car owner must acquire this cover. Exceptions
                              include car owners without a driving license or
                              those with an existing accident cover.
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box>
                              Please choose &apos;PA&apos; in the top left
                              corner.
                            </Box>
                          </>
                        )
                      }
                    >
                      <img
                        src={infoToolTip}
                        alt={infoToolTip}
                        className={classes.infoImage}
                      />
                    </Tooltip>
                  </Box>
                  <Box>
                    <span className={classes.paAmount}>
                      {formatToINR(quote?.paPremium)}
                    </span>
                  </Box>
                </Box>
              </Box>
            ) : null}

            <Box className={classes.viewPlan}>
              <Box
                className={classes.planDetails}
                onClick={handleViewPlanDetails}
              >
                View Plan Details
              </Box>
              <Box>
                <ChevronRightIcon
                  fontSize='7px'
                  className={classes.commonColor}
                />
              </Box>
            </Box>

            <Box>
              <Button
                className={classes.btn}
                endIcon={<ChevronRightIcon className={classes.buttonIcon} />}
                onClick={handleQuoteClick}
                id='priceButton'
              >
                {formatToINR(price)}
              </Button>
            </Box>
          </Box>
          {isCoverageAvailable && (
            <Box>
              <Divider variant='middle' />
              <Box className={classes.featuresContainer}>
                {DRIVE_FEATURES?.map((features) => {
                  return (
                    <Box className={classes.featureContent} key={features?.id}>
                      <span className={classes.featureAction}>
                        {features?.name}
                      </span>
                    </Box>
                  )
                })}
              </Box>
            </Box>
          )}
          {selectedAddOns?.length > 0 && (
            <>
              <Divider variant='middle' />
              <Box
                className={classes.addOnsTitleContainer}
                onClick={() => setShowAddOns(!showAddOns)}
              >
                <Box
                  className={classes.coverageTitle}
                >{`${quote?.addOns?.length}/${currentPolicyDetails?.addOns?.length} selected addons`}</Box>
                <Box>
                  {showAddOns ? (
                    <KeyboardArrowUpIcon className={classes.coverageTitle} />
                  ) : (
                    <KeyboardArrowDownIcon
                      className={classes.coverageTitle}
                      onClick={() => setShowAddOns(!showAddOns)}
                    />
                  )}
                </Box>
              </Box>

              {showAddOns ? (
                <Grid container spacing={2}>
                  {selectedAddOns?.map((feature) => (
                    <Grid
                      className={classes.coverageFeature}
                      key={feature?.id}
                      item
                      xs={12}
                      sm={6}
                    >
                      <Box className={classes.addOnsItem}>
                        <span> {getIconById(feature?.id)}</span>
                        <span className={classes.featureAction}>
                          {feature?.coverage}
                        </span>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : null}
            </>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default ComprehensivePlan

const useStyles = makeStyles({
  backgroundContainer: {
    background: 'linear-gradient(to bottom, #B6D1D9 , #FFFFFF )',
    padding: '1px',
    borderRadius: '11px',
    position: 'relative',
  },
  quoteCardContainer: {
    borderRadius: '10px',
    boxShadow: '0px 8px 8px 0px  #0000001A',
    background: COLORS.WHITE,
    zIndex: 1,
    padding: '10px',
  },
  quoteCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    flexWrap: 'wrap',
  },
  logoContainer: {},
  logoImage: {
    width: '60px ',
    height: '40px ',
  },
  heading: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    color: '#666666',
  },
  data: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
    letterSpacing: '0em',
    color: '#000000',
  },
  commonColor: {
    color: '#2695B4',
  },
  btn: {
    color: '#FFFFFF',
    background: 'linear-gradient(87.86deg, #59ADCA -1.42%, #60B9E0 154.94%)',
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '14.06px',
    letterSpacing: '0em',
    padding: '6px 8px 4px 10px',
  },
  quoteDetailsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  checkboxText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '12.89px',
    letterSpacing: '0em',
    color: '#2695B4',
    margin: '3px 0px 0px -8px',
  },
  planDetails: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '12.89px',
    letterSpacing: '0em',
    color: '#2695B4',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  viewPlan: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderImageSource: 'linear-gradient(180deg, #B6D1D9 0%, #FFFFFF 100%)',
    borderImageSlice: 1,
  },
  recommendedCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 14,
    marginTop: '-3px',
  },
  recommendedLogo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',

    borderRadius: '0px 0px 10px 10px',
    background: 'linear-gradient(277.71deg, #f59fc0 3.07%, #FFFFFF 99.03%)',
    width: 'fit-content',
    padding: '0px 10px',
  },
  recommendedByText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#651E34',
  },
  recommendedByValue: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#651E34',
  },
  recommendedMessage: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '12.89px',
    letterSpacing: '0em',
    color: '#818080',
    paddingTop: '3px',
  },
  featureAction: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    color: '#545454',
  },
  featuresContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    padding: '14px',
    alignItems: 'center',
    columnCount: 2,
    columnGap: '20px',
  },
  buttonIcon: {
    marginLeft: '-8px',
  },
  paCoverProviderName: {
    fontFamily: 'Roboto',
    fontWeight: '700',
    fontSize: '12px',
    color: '#2BA6C8',
    lineHeight: '14.06px',
    textAlign: 'right',
    paddingBottom: '5px',
  },
  paCoverText: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14.06px',
  },
  infoImage: {
    height: '15px',
    width: '15px',
    padding: '0px 8px',
  },
  paAmount: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '14.06px',
  },
  addToCompareSection: {
    position: 'absolute',
    right: '0px',
  },
  paCoverTileText: { display: 'flex', flexDirection: 'row' },
  paCoverDisabled: { opacity: 0.1 },
  addOnsItem: {
    display: 'flex',
    gap: 10,
  },
  checkAddOn: {
    color: 'green',
    fontSize: '6px',
    marginTop: '-4px',
    '& .css-i4bv87-MuiSvgIcon-root': {
      fontSize: '6px !important',
    },
  },
  crossAddOn: {
    color: 'red',
    fontSize: '6px',
    marginTop: '-4px',
    '& .css-i4bv87-MuiSvgIcon-root': {
      fontSize: '6px !important',
    },
  },
  coverageTitle: {
    paddingTop: '5px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#545454',
  },
  addOnsTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '0px 10px',
    cursor: 'pointer',
  },
  quote: {
    paddingBottom: '30px',
  },
})
